export const state = () => ({
  loading: false,
  items: null,
  eventInformation: []
})
export const getters = {
  loading(state) {
    return state.loading
  },
  items(state) {
    return state.items
  },
  eventInformation(state) {
    return state.eventInformation
  }
}
export const mutations = {
  setLoading(state, newState) {
    state.loading = newState
  },
  setItems(state, { data }) {
    state.items = data
  },
  setEventInformation(state, { data, reset, folderName }) {
    if (reset) {
      state.eventInformation = []
    } else if (folderName) {
      data.folderName = folderName
      state.eventInformation.push(data)
    }
  }
}
export const actions = {
  getEvents({ commit, rootState }) {
    return this.$axios
      .get(`${rootState.language}/homepage/events/events.json`)
      .then((res) => {
        commit('setItems', { data: res.data })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getEventInformation({ commit, rootState }, { folderName }) {
    return this.$axios
      .get(`${rootState.language}/homepage/events/${folderName}/stage.json`)
      .then((res) => {
        commit('setEventInformation', {
          data: res.data,
          folderName: folderName
        })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getLocation({ commit, rootState }, { folderName }) {
    return this.$axios
      .get(`${rootState.language}/homepage/events/${folderName}/location.json`)
      .then((res) => {
        commit('setLocation', {
          data: res.data,
          folderName: folderName
        })
      })
      .catch((err) => {
        console.error(err)
      })
  },
  getAgenda({ commit, rootState }, { folderName }) {
    return this.$axios
      .get(`${rootState.language}/homepage/events/${folderName}/agenda.json`)
      .then((res) => {
        commit('setAgenda', {
          data: res.data,
          folderName: folderName
        })
      })
      .catch((err) => {
        console.error(err)
      })
  }
}
